import React from 'react';

const ChatTestimonials = () => {
  const chatImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/r7srli0m_Screenshot%202026-03-19%20at%205.07.36%20PM.png',
      alt: 'Christie - 5 figure job, doubled salary, shorter hours'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/40t8wxy9_Screenshot%202026-03-19%20at%205.07.52%20PM.png',
      alt: 'Wei Ming - Strong energy, new customer orders'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/5zfckdez_Screenshot%202026-03-19%20at%205.08.07%20PM.png',
      alt: 'Tang Chee Yik - Sales without negotiation'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/b16sllv9_Screenshot%202026-03-19%20at%205.12.35%20PM.png',
      alt: 'Client - More opportunities and noble men'
    }
  ];

  return (
    <div className="py-24 bg-[#111113]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase mb-4">
            Real Results from Real People
          </p>
          <h2 className="text-5xl font-bold text-white mb-6">
            Testimonials
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            See what our clients are saying about their signature transformation journey
          </p>
        </div>

        <div className="flex flex-col items-center gap-8 max-w-2xl mx-auto">
          {chatImages.map((chat, index) => (
            <img 
              key={index}
              src={chat.url}
              alt={chat.alt}
              className="w-full h-auto object-contain rounded-xl"
            />
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-400 text-sm italic">
            Authentic client messages showing real transformation results
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChatTestimonials;
